// extracted by mini-css-extract-plugin
export default {"element":"element--Ml0U","title":"title--MLsr","locked":"locked--8VED"};